export enum LAYOUT_TYPE {
  SINGLE_COLUMN_LAYOUT = 'SINGLE_COLUMN_LAYOUT',
  TWO_COLUMN_LAYOUT = 'TWO_COLUMN_LAYOUT',
}

export enum SOCIAL_LAYOUT_TYPE {
  LAYOUT_ONE = 'LAYOUT_ONE',
  LAYOUT_TWO = 'LAYOUT_TWO',
}
